module.exports = __webpack_public_path__ + "img/1006835390.5140a81f.png";